export const PositionNotification = {
  topLeft: { top: 0, left: 0, alignItems: 'flex-start' },
  topCenter: { top: 0, left: '50%', transform: 'translateX(-50%)' },
  topRight: { top: 0, right: 0, alignItems: 'flex-end' },
  bottomLeft: { bottom: 0, left: 0, alignItems: 'flex-start' },
  bottomCenter: { bottom: 0, left: '50%', transform: 'translateX(-50%)' },
  bottomRight: { bottom: 0, right: 0, alignItems: 'flex-end' },
};
